import React from 'react';
import LoginForm from '../components/login/LoginForm';
import { motion } from 'framer-motion';
import Logo from '../components/shared/Logo';

const LoginPage: React.FC = () => {
  return (
    <div className="min-h-dvh bg-surface flex flex-col lg:flex-row font-sans">
      {/* Brand Section - Hidden on mobile */}
      <div className="hidden lg:flex lg:w-1/2 bg-surface-container-lowest relative overflow-hidden items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative z-20 text-center px-6 sm:px-12"
        >
          <div className="flex items-center justify-center mx-auto mb-8">
            <Logo className="h-16 w-auto" variant="default" />
          </div>
          <p className="text-xl text-on-surface-variant max-w-md mx-auto leading-relaxed">
            Empowering the next generation of storytellers with
            professional-grade production tools.
          </p>
        </motion.div>
      </div>

      {/* Form Section */}
      <div className="flex-1 flex flex-col justify-center items-center p-8 lg:p-24 bg-surface">
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="w-full max-w-md"
        >
          {/* Mobile Logo */}
          <div className="lg:hidden text-center mb-12">
            <Logo className="h-10 mx-auto" variant="invert" />
          </div>

          <div className="mb-10 text-center lg:text-left">
            <h2 className="text-3xl font-bold text-on-surface mb-2 tracking-tight">
              Welcome back
            </h2>
            <p className="text-on-surface-variant">
              Log in to your creative workspace
            </p>
          </div>

          <LoginForm />

          <div className="mt-8 text-center">
            <p className="text-on-surface-variant text-sm">
              Don't have an account?{' '}
              <a
                href="/signup"
                className="text-tertiary font-semibold hover:underline decoration-2 underline-offset-4"
              >
                Sign up for free
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LoginPage;
